var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerInsuranceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon insurance",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38v38H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.91.216a2.419 2.419 0 0 0-2 0L18.858 6.179A4.633 4.633 0 0 0 16 10.448c.037 7.4 3.082 20.948 15.94 27.1a4.558 4.558 0 0 0 3.94 0c12.858-6.157 15.9-19.7 15.94-27.1a4.633 4.633 0 0 0-2.858-4.269zm-9.358 16.3a4.575 4.575 0 0 1 7.806-3.239l.552.552.552-.552a4.575 4.575 0 0 1 6.47 6.47l-6.172 6.172a1.2 1.2 0 0 1-1.687 0L26.9 19.746a4.57 4.57 0 0 1-1.336-3.231z",
    style: {
      fill: "#414b5a"
    },
    transform: "translate(-15.541)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerInsuranceIcon);
export default __webpack_public_path__ + "static/media/partner-insurance-icon.3ca7ee88de354a4f29b634015f288255.svg";
export { ForwardRef as ReactComponent };